<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="chatList" class="container ">
  <div class="row justify-content-center">
    <div class="col-8">
      <h2 class="lifedi-color text-center mt-2">
        {{ courseName }}
      </h2>
    </div>
  </div>

  <div class="container">
    <mat-card *ngIf="chatList.length === 0 " class="row mt-4 mb-3">
      <h3 class="col-12 text-center" style="margin: 16px 0; color: #ccc;">ยังไม่มีการสนทนา</h3>
    </mat-card>
    <div *ngIf="chatList.length > 0" class="row">

      <!-- mobile size -->
      <mat-card *ngFor="let c of chatList; let i = index" [ngClass]="{'mt-3': i === 0}"
        class="col-12 mb-3 card-main d-none d-block d-sm-block d-md-none">
        <mat-card-content>
          <div class="col-12 inline-block">
            <div style="margin: 5px 0 10px; width: 100%; display: inline-flex;">
              <img class="d-none d-block d-sm-block d-md-none" width="40px" height="40px" style="border-radius: 50%;"
                [src]="c.PROFILE_PIC">
              <div class="ml-3">
                <span style="display: inline; line-height: 2.8;">{{ c.CHAT_USERNAME }}</span>
                <div style="position: absolute; right: 15px; top: 4px;">
                  <img src="../../../../assets/bin.png" alt="" style="width: 15px; float: right; cursor: pointer;"
                    (click)="delete(c.CHAT_ID, c.CHAT_NUMBER, c.CHAT_MESSAGE)"><br>
                  <span>ความคิดเห็นที่ {{ c.CHAT_NUMBER }}</span><br>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div style="width: 100%;">
              <mat-card class="col-12" style="background: #f6f6f6; border: 1px solid #ddd;">
                {{ c.CHAT_MESSAGE }}
              </mat-card>
            </div>
          </div>
          <div class="col-12">
            <small style="float: right;">{{ c.CREATE_DATE | dateTime }}</small>
          </div>
        </mat-card-content>
        <!-- <hr *ngIf="c?.SUB_CHAT.length > 0" width="80%"> -->
        <div class="row" style="width: 100%;">
          <mat-card *ngFor="let sc of c.SUB_CHAT; let j = index;" class="offset-1 col-11" style="padding-top: 7px;">
            <div class="col-12 inline-block">
              <div style="margin: 5px 0 10px; width: fit-content;">
                <img class="d-none d-block d-sm-block d-md-none" width="40px" height="40px" style="border-radius: 50%;"
                  [src]="sc.PROFILE_PIC">
              </div>
              <div class="ml-3">
                <span style="display: inline;  line-height: 3.5;">{{ sc.CHAT_USERNAME }}</span>
                <div style="position: absolute; right: 15px; top: 4px;">
                  <img src="../../../../assets/bin.png" alt="" style="width: 15px; float: right; cursor: pointer;"
                    (click)="delete(sc.CHAT_ID, sc.CHAT_NUMBER, sc.CHAT_MESSAGE)"><br>
                  <span>ความคิดเห็นที่ {{ sc.CHAT_NUMBER }}</span><br>
                </div>
              </div>
            </div>
            <div class="col-12 inline-block">
              <div style="width: 100%;">
                <mat-card style="background: #f6f6f6; border: 1px solid #ddd;">
                  {{ sc.CHAT_MESSAGE }}
                </mat-card>
              </div>
            </div>
            <div class="col-12">
              <small style="float: right;">{{ sc.CREATE_DATE | dateTime }}</small>
            </div>
          </mat-card>
        </div>
      </mat-card>

      <!-- desktop size -->
      <mat-card *ngFor="let c of chatList; let i = index" [ngClass]="{'mt-3': i === 0}"
        class="col-12 mb-3 card-main d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
        <div class="row">
          <div class="col-3 text-center">
            <div style="margin: 5px auto 0; width: fit-content;">
              <img class="d-none d-md-block d-lg-block d-xl-block" width="50px" height="50px"
                style="border-radius: 50%; margin: 0 auto;" [src]="c.PROFILE_PIC">
              <p class="mt-2">{{ c.CHAT_USERNAME }}</p>
            </div>
          </div>
          <div class="col-8">
            <div style="width: 100%;">
              <p>ความคิดเห็นที่ {{ c.CHAT_NUMBER }}
                <img src="../../../../assets/bin.png" alt="" style="width: 20px; float: right; cursor: pointer;"
                  (click)="delete(c.CHAT_ID, c.CHAT_NUMBER, c.CHAT_MESSAGE)">
              </p>
              <mat-card class="col-12" style="background: #f6f6f6; border: 1px solid #ddd;">
                {{ c.CHAT_MESSAGE }}
              </mat-card>
              <span class="d-none d-sm-none d-md-block mt-2" style="display: inline; float: right;">
                {{ c.CREATE_DATE | dateTime }}
              </span>
            </div>
          </div>
        </div>
        <hr *ngIf="c?.SUB_CHAT.length > 0" width="80%">
        <div class="row">
          <mat-card *ngFor="let sc of c.SUB_CHAT; let j = index;" class="offset-1 col-10">
            <div class="row">
              <div class="col-3 text-center inline-block">
                <div style="margin: 5px auto 0; width: fit-content;">
                  <img class="d-none d-md-block d-lg-block d-xl-block" width="50px" height="50px"
                    style="border-radius: 50%; margin: 0 auto;" [src]="sc.PROFILE_PIC">
                  <p class="mt-2">{{ sc.CHAT_USERNAME }}</p>
                </div>
              </div>
              <div class="col-9 inline-block">
                <div style="width: 100%;">
                  <p>ความคิดเห็นที่ {{ sc.CHAT_NUMBER }}
                    <img src="../../../../assets/bin.png" alt="" style="width: 20px; float: right; cursor: pointer;"
                      (click)="delete(sc.CHAT_ID, sc.CHAT_NUMBER, sc.CHAT_MESSAGE)">
                  </p>
                  <mat-card style="background: #f6f6f6; border: 1px solid #ddd;">
                    {{ sc.CHAT_MESSAGE }}
                  </mat-card>
                  <span class="d-none d-sm-none d-md-block mt-2" style="display: inline; float: right;">
                    {{ sc.CREATE_DATE | dateTime }}
                  </span>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </mat-card>
    </div>
    <!-- <div class="row justify-content-center">
      <a (click)="readChatMore()">ดูรีวิวเพิ่มเติม</a>
    </div> -->
  </div>
